import { render, staticRenderFns } from "./DuplicatedPatientIndicator.vue?vue&type=template&id=422619e9&scoped=true&"
import script from "./DuplicatedPatientIndicator.vue?vue&type=script&lang=ts&"
export * from "./DuplicatedPatientIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicatedPatientIndicator.vue?vue&type=style&index=0&id=422619e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422619e9",
  null
  
)

export default component.exports